import classNames from 'classnames'

import { getQaSelector } from '../../../../../../utils/common'
import { Status, STATUS_SIZE_20 } from '../../../../../Status'
import Text from '../../../../../Text'
import { ApplicantDecisionNote } from '../ApplicantDecisionNote'
import { ApplicantDecisionUser } from '../ApplicantDecisionUser'

import * as styles from './ApplicantDecisionPerson.module.css'

function ApplicantDecisionPerson({
  isMuted,
  note,
  qaName,
  statusProps,
  text,
  user,
}) {
  return (
    <div
      {...getQaSelector({ value: qaName })}
      className={styles.ApplicantDecisionPerson}
    >
      <div className={styles.head}>
        {user ? <ApplicantDecisionUser isMuted={isMuted} value={user} /> : null}
        {statusProps ? (
          <Status {...statusProps} height={STATUS_SIZE_20} />
        ) : null}
        {text ? (
          <Text
            isSecondary
            className={classNames(styles.text, { [styles.muted]: isMuted })}
          >
            {text}
          </Text>
        ) : null}
      </div>
      {note ? <ApplicantDecisionNote {...note} /> : null}
    </div>
  )
}

export default ApplicantDecisionPerson
